import { Link } from 'react-router-dom';
import { Loader2, PhoneCall } from 'lucide-react';
import { BucketBadge } from '@/components/BucketBadge';
import { useApiQuery, type BriefResponse } from '@/lib/api';

export function Brief() {
  const { data, loading, error } = useApiQuery<BriefResponse>('/api/brief?limit=25');
  const items = data?.items ?? [];

  return (
    <div className="container mx-auto max-w-5xl px-6 py-10">
      <header className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-primary">Today</p>
          <h1 className="mt-1 text-3xl font-bold tracking-tight">Who to call today</h1>
          <p className="mt-2 text-muted-foreground">
            Most at-risk members first, with why. {data && `${items.length} prioritized.`}
          </p>
        </div>
        {loading && <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />}
      </header>

      {error && <p className="mt-6 rounded-md bg-destructive/10 px-4 py-3 text-sm text-destructive">{error}</p>}

      {!loading && items.length === 0 && !error && (
        <p className="mt-8 rounded-xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
          No at-risk members surfaced. Run a rescore once more engagement signals are ingested.
        </p>
      )}

      <ul className="mt-8 space-y-3">
        {items.map((m) => (
          <li key={m.profileId} className="rounded-xl border border-border bg-card p-5 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <Link to={`/members/${m.profileId}`} className="font-semibold text-primary hover:underline">
                  {m.legalName ?? m.profileId}
                </Link>
                <ul className="mt-2 space-y-0.5 text-sm text-muted-foreground">
                  {m.reasons.map((r, i) => (
                    <li key={i}>· {r}</li>
                  ))}
                </ul>
                <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-foreground">
                  <PhoneCall className="h-4 w-4 text-primary" />
                  {m.suggestedAction}
                </p>
              </div>
              <div className="shrink-0 text-right">
                <BucketBadge bucket={m.bucket} />
                <p className="mt-2 text-xs text-muted-foreground">score {m.score}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
